export default __webpack_public_path__ + "static/media/opaper_loading.f66ba6e8.gif";